import { render, staticRenderFns } from "./aliBey.vue?vue&type=template&id=12ee0e79&scoped=true"
import script from "./aliBey.vue?vue&type=script&lang=js"
export * from "./aliBey.vue?vue&type=script&lang=js"
import style0 from "./aliBey.vue?vue&type=style&index=0&id=12ee0e79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ee0e79",
  null
  
)

export default component.exports